import React, { Component } from "react"
import "./AboutUs.css"
import { StaticQuery, graphql } from "gatsby"
import { ArrowForward } from "@material-ui/icons"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"


export class AboutUs extends Component {
  constructor() {
    super()
    this.state = {
      expanded: false,
      text: "More",
      expandedArticle: false,
      word: "All",
    }
  }

  expandedText = () => {
    this.setState({
      expanded: true,
      text: "Less",
    })
  }
  contractText = () => {
    this.setState({
      expanded: false,
      text: "More",
    })
  }

  expandArticle = () => {
    this.setState({
      expandedArticle: true,
      word: "Less",
    })
  }
  contractArticle = () => {
    this.setState({
      expandedArticle: false,
      word: "All",
    })
  }

  getMoreTextDiv = () => {
    if (this.state.expanded) {
      return (
        <div>
               {this.props.about.edges.map(edge => {
return(
        <p className="justify-para" style={{ lineHeight: "1.5rem" }}>
                {/* {edge.node.aboutTitle} */}
                {documentToReactComponents(edge.node.readmoreText.json, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, Children) => (
                <p>{Children}</p>
              ),
           
            },
          })}
        </p>
)
})}
      
        </div>
      )
    } else if (!this.state.expanded) {
      return null
    }
  }

  getMoreArticle = () => {
    if (this.state.expandedArticle) {
      return (
        <div>
           {this.props.articles.edges.slice(5,10).map(edge => {
return(
              <div 
              className="text-placement pt-1 pt-sm-2 pt-md-3 pt-lg-5 pt-xl-5"
              >

                {documentToReactComponents(edge.node.title.json, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, Children) => (
         
                <p >{Children}</p>
                

              ),
           
            },
          })}
       
        </div>
)
})}
          </div>
      )
    } else if (!this.state.expandedArticle) {
      return null
    }
  }
  render() {
    var expandedDiv = this.getMoreTextDiv()
    var articleText = this.getMoreArticle()
    console.log(this.props.video)

    return (
      <div className="container-fluid">
        {/* <div className="bg-dark"> <image src={player}  style={{zIndex: '22'}}/></div> */}
        <div className="row">
          {/* <img src={blog} style={{ width: "100%" }} /> */}
          {this.props.about.edges.map(edge => {
            return (
              <div className="col-12">
                <iframe
                  style={{
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                  className="video-size"
                  src={edge.node.video}
                  frameborder="0"
                  allowfullscreen
                ></iframe>
                <div className="rectangle-red"></div>
                <div className="rectangle-text">
                  {/* <p className="ted" >
                    TED Talk
                  </p> */}
                  {/* <br/> */}
                <p>{edge.node.date}</p>
                </div>
              </div>
            )
          })}

          <div className="col-12">
            <br />
          {this.props.about.edges.map(edge => {
return(
        <h1 className="about-heading">{edge.node.aboutTitle}</h1>
)
})}
            {/* <div className="red-underline about-under" ></div> */}
            <div class="row ">
              <div class="col-sm-4  d-flex justify-content-start">
                <div className="red-underline"></div>
              </div>
              <div class="col-sm-3"></div>
              <div class="col-sm-5"></div>
            </div>
            <br />
            <div>
            {this.props.about.edges.map(edge => {
return(
        <p className="justify-para" style={{ lineHeight: "1.5rem" }}>
                {/* {edge.node.aboutTitle} */}
                {documentToReactComponents(edge.node.aboutText.json, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, Children) => (
                <p>{Children}</p>
              ),
           
            },
          })}
        </p>
)
})}
      
             
              {expandedDiv}
            </div>
            <br />
            <div className="read-more">
              <a
     
     style={{ color: "black" , borderBottom: '1px solid black'}}
                onClick={
                  !this.state.expanded ? this.expandedText : this.contractText
                }
              >
                Read {this.state.text}
              </a>
            </div>
          </div>
        </div>
        <br />

       
        <div className="row mt-sm-5 pt-sm-5">
          <div className="col-12">
            <h1 className="about-heading">Articles</h1>

            <div class="row ">
              <div class="col-sm-4 d-flex justify-content-start">
                <div className="blue-underline"></div>
              </div>
              <div class="col-sm-3"></div>
              <div class="col-sm-5 "></div>
            </div>
          </div>
          <div className="col-5 col-md-5 col-sm-6 frame">
            {/* <div className="row"> */}

              {/* <div className="d-flex justify-content-center"> */}
                {/* <a
                  href="https://www.amazon.com/Messing-Enemy-Surviving-Terrorists-Russians/dp/0062795988?"
                  className="read-more"
                  >
                  The Book
                </a>{" "} */}
                {this.props.about.edges.map(edge => {
return(
                <div >
                  <img src={edge.node.bookImage.fluid.src} style={{ marginBottom: "0px" }} />
              <div 
              className="d-flex justify-content-center"
              style={{color:'black'}}
              >

                {documentToReactComponents(edge.node.bookLink.json, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, Children) => (
         
                <p
                
                className="read-more"
                style={{color:'black'}}
              >
               {Children}
              </p>
                

              ),
           
            },
          })}
       &nbsp;
       <ArrowForward />
       
        </div>
            </div>
)
})}

              {/* </div> */}
             
          </div>
          <div className="col-7 col-sm-6 col-md-7">
            <div>
              {this.props.articles.edges.slice(0,5).map(edge => {
return(
              <div 
              className="text-placement pt-1 pt-sm-2 pt-md-3 pt-lg-5 pt-xl-5"
              >

                {documentToReactComponents(edge.node.title.json, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (node, Children) => (
         
                <p >{Children}</p>
                

              ),
           
            },
          })}
       
        </div>
)
})}

              </div>
              
              
              {articleText}

              <div
                className="top-space d-flex justify-content-sm-end"
                style={{
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  cursor: "pointer",
                }}
              >
                <a
                 style={{ color: "black" , borderBottom: '1px solid black'}}
                  className="read-more"
                  onClick={
                    !this.state.expandedArticle
                      ? this.expandArticle
                      : this.contractArticle
                  }
                >
                  View {this.state.word}
                </a>
              </div>
            </div>
          </div>
        {/* </div> */}
      </div>
    )
  }
}

export default () => (
  <StaticQuery
  query={graphql`
  query{
    allContentfulAboutPage {
      edges {
        node {
          aboutText {
            json
          }
          aboutTitle
          video
          date
          readmoreText {
            json
          }
          bookImage {
            fluid {
              src
            }
          }
          bookLink {
            json
          }
        }
      }
    }
    allContentfulArticles {
      edges {
        node {
          title {
            json
          }
         
        }
      }
    }
  }
  `}
  
  render={(data) => (
    <AboutUs  about={data.allContentfulAboutPage} articles={data.allContentfulArticles}/>
  )}
  />
)
